var _defs, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPmPhase3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1345.65 1515.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1-pm-3, .cls-2-pm-3, .cls-3-pm-3, .cls-4-pm-3, .cls-5-pm-3 {\n        fill: #fff;\n      }\n\n      .cls-1-pm-3, .cls-6-pm-3, .cls-7-pm-3, .cls-8-pm-3, .cls-9-pm-3 {\n        stroke: rgba(0, 0, 0, 0);\n      }\n\n      .cls-10-pm-3 {\n        stroke: #1a3378;\n      }\n\n      .cls-10-pm-3, .cls-8-pm-3 {\n        fill: #1a3378;\n      }\n\n      .cls-11-pm-3, .cls-12-pm-3, .cls-13-pm-3, .cls-14-pm-3, .cls-15-pm-3, .cls-3-pm-3, .cls-16-pm-3, .cls-17-pm-3, .cls-18-pm-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-11-pm-3, .cls-19-pm-3, .cls-20-pm-3 {\n        fill: #008573;\n      }\n\n      .cls-2-pm-3, .cls-21-pm-3 {\n        stroke: #4c535d;\n        stroke-width: .2px;\n      }\n\n      .cls-22-pm-3 {\n        fill: url(#linear-gradient-2-pm-3);\n      }\n\n      .cls-22-pm-3, .cls-23-pm-3 {\n        stroke: #1071e5;\n      }\n\n      .cls-21-pm-3, .cls-18-pm-3 {\n        fill: #e81313;\n      }\n\n      .cls-6-pm-3 {\n        fill: #ffe342;\n      }\n\n      .cls-12-pm-3 {\n        fill: #ebf5fe;\n      }\n\n      .cls-19-pm-3, .cls-23-pm-3 {\n        stroke-width: .05px;\n      }\n\n      .cls-19-pm-3, .cls-20-pm-3, .cls-4-pm-3, .cls-5-pm-3, .cls-24-pm-3, .cls-25-pm-3 {\n        stroke: #008573;\n      }\n\n      .cls-7-pm-3 {\n        fill: url(#linear-gradient-pm-3);\n      }\n\n      .cls-14-pm-3, .cls-24-pm-3 {\n        fill: none;\n      }\n\n      .cls-15-pm-3 {\n        fill: #333;\n      }\n\n      .cls-23-pm-3, .cls-17-pm-3 {\n        fill: #1071e5;\n      }\n\n    \n      .cls-16-pm-3 {\n        fill: #2f5496;\n      }\n\n      .cls-9-pm-3 {\n        fill: url(#linear-gradient-3-pm-3);\n      }\n\n      .cls-25-pm-3 {\n        fill: #edeef0;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-pm-3",
    x1: 506.27,
    y1: 1821.97,
    x2: 506.27,
    y2: 1653.31,
    gradientTransform: "translate(122.96 1969.22) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#00c2a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00c2a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008573"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2-pm-3",
    x1: -24.45,
    y1: 1786.98,
    x2: -24.45,
    y2: 1688.31,
    gradientTransform: "translate(122.96 1969.22) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#cfe4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1071e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3-pm-3",
    x1: 503.44,
    y1: 1282.81,
    x2: 503.44,
    y2: 1114.16,
    gradientTransform: "translate(122.96 1969.22) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#00c2a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00c2a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008573"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "rect6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-pm-3",
    d: "m455.26,1251.68c0-3.31,2.69-6,6-6h330.26c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6h-330.26c-3.31,0-6-2.69-6-6v-86.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "am",
    className: "cls-13-pm-3",
    d: "m550.95,1284.15h-2.72l-3.8-14.26-3.73,14.26h-2.72l-4.96-16.84h2.38l4.01,14.8,1.02-4.35,2.92-10.46h2.17l4.01,14.8,4.01-14.8h2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an",
    className: "cls-13-pm-3",
    d: "m564.6,1281.7c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao",
    className: "cls-13-pm-3",
    d: "m576.35,1273.08c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap",
    className: "cls-13-pm-3",
    d: "m583.48,1270.97c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq",
    className: "cls-13-pm-3",
    d: "m597.47,1272.67c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar",
    className: "cls-13-pm-3",
    d: "m610.64,1270.97c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as",
    className: "cls-13-pm-3",
    d: "m623.13,1284.42c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at",
    className: "cls-13-pm-3",
    d: "m640.18,1274.44c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-2",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m650.02,1270.97c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "at-2",
    "data-name": "at",
    className: "cls-13-pm-3",
    d: "m672.77,1274.44c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au",
    className: "cls-13-pm-3",
    d: "m679.83,1280.95c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-2",
    "data-name": "ar",
    className: "cls-13-pm-3",
    d: "m689.4,1270.97c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av",
    className: "cls-13-pm-3",
    d: "m702.71,1272.67c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw",
    className: "cls-13-pm-3",
    d: "m718.13,1284.15l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ax",
    className: "cls-13-pm-3",
    d: "m569.8,1302c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-2",
    "data-name": "an",
    className: "cls-13-pm-3",
    d: "m585.41,1311.04c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay",
    className: "cls-13-pm-3",
    d: "m597.36,1300.31c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-3",
    "data-name": "an",
    className: "cls-13-pm-3",
    d: "m612.57,1311.04c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az",
    className: "cls-13-pm-3",
    d: "m628.6,1300.58c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04Zm-5.64,11.41c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-3",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m636.95,1300.31c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-2",
    "data-name": "ax",
    className: "cls-13-pm-3",
    d: "m658,1302c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-4",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m670.83,1300.31c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-2",
    "data-name": "ay",
    className: "cls-13-pm-3",
    d: "m685.57,1300.31c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-2",
    "data-name": "au",
    className: "cls-13-pm-3",
    d: "m695.21,1310.29c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rect1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-pm-3",
    d: "m457.86,6.5c0-3.31,2.69-6,6-6h330.24c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6h-330.24c-3.31,0-6-2.69-6-6V6.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aA",
    className: "cls-13-pm-3",
    d: "m566.54,55.65v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-3",
    "data-name": "ay",
    className: "cls-13-pm-3",
    d: "m579.04,42.48c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB",
    className: "cls-13-pm-3",
    d: "m586.3,39.96v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-3",
    "data-name": "au",
    className: "cls-13-pm-3",
    d: "m594.04,52.46c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-2",
    "data-name": "aB",
    className: "cls-13-pm-3",
    d: "m598.46,39.96v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-4",
    "data-name": "an",
    className: "cls-13-pm-3",
    d: "m611.76,53.2c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-4",
    "data-name": "au",
    className: "cls-13-pm-3",
    d: "m619.78,52.46c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-5",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m629.35,42.48c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aC",
    className: "cls-13-pm-3",
    d: "m659.23,55.65l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD",
    className: "cls-13-pm-3",
    d: "m665.27,55.65v-16.84h2.24v15.01h8.49v1.83h-10.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aE",
    className: "cls-13-pm-3",
    d: "m692.63,43.63c-.07,2.78-1.56,4.35-4.07,4.75l4.75,7.27h-2.58l-4.41-6.99h-5.23v6.99h-2.24v-16.84c5.98.2,13.92-1.43,13.78,4.82Zm-11.54,3.26c4.07-.14,9.3.88,9.3-3.19s-5.43-2.85-9.3-3.06v6.25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "diamond1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7-pm-3",
    d: "m623.86,149.9c3.39-1.67,7.37-1.67,10.76,0l160.36,79.03c1.46.73,2.06,2.51,1.33,3.97-.29.58-.75,1.04-1.33,1.33l-160.36,79.03c-3.4,1.67-7.38,1.67-10.77,0l-160.37-79.04c-1.46-.73-2.06-2.51-1.33-3.97.29-.58.75-1.04,1.33-1.33l160.38-79.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aF",
    className: "cls-3-pm-3",
    d: "m577.68,236.4l.14-13.85-4.35,13.85h-2.51l-4.28-13.85.14,13.85h-3.12v-16.84h4.75l3.8,12.56,3.87-12.56h4.69v16.84h-3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aG",
    className: "cls-3-pm-3",
    d: "m583.99,236.4v-16.84h3.53v14.12h9.03v2.72h-12.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aH",
    className: "cls-3-pm-3",
    d: "m613.53,224.58c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02Zm-11.14,2.72c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aI",
    className: "cls-3-pm-3",
    d: "m631.59,236.4h-3.6l-6.25-16.84h3.73l4.35,13.99c1.15-4.89,2.85-9.3,4.28-13.99h3.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ",
    className: "cls-3-pm-3",
    d: "m649.11,233.14c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aK",
    className: "cls-3-pm-3",
    d: "m659.29,226.21c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aL",
    className: "cls-3-pm-3",
    d: "m665.61,223.22c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72Zm1.15,11.14c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aM",
    className: "cls-3-pm-3",
    d: "m676.2,221.19v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aN",
    className: "cls-3-pm-3",
    d: "m694.2,232.12c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aO",
    className: "cls-3-pm-3",
    d: "m702.68,236.19c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-24-pm-3",
    d: "m628.98,100.17l.17,33.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19-pm-3",
    d: "m629.48,100.18h-1v-.5h1v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20-pm-3",
    d: "m629.22,148.66l-4.7-14.24,9.27-.05-4.57,14.29Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "rect8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22-pm-3",
    d: "m.5,188.24c0-3.31,2.69-6,6-6h184.02c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-86.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aP",
    className: "cls-3-pm-3",
    d: "m44.65,224.38c-.06-2.65-5.8-2.84-5.99-.19,1.11,4.07,9.32.62,9.51,7.04.19,5.86-10.19,5.74-12.59,2.22-.37-.49-.62-1.17-.74-1.85l3.09-.49c.19,2.84,6.91,3.46,7.16.31-1.05-4.26-9.26-.62-9.51-7.04-.25-5.37,9.44-5.43,11.6-2.16.31.49.49,1.11.62,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ-2",
    "data-name": "aJ",
    className: "cls-3-pm-3",
    d: "m60.45,232.65c-.8,1.85-2.28,3.27-5.06,3.21-3.7-.12-5.49-2.28-5.49-6.17s1.85-6.05,5.56-6.05,5.12,2.78,5.19,6.67h-7.53c0,1.91.49,3.4,2.41,3.46,1.11,0,1.85-.43,2.1-1.36l2.84.25Zm-2.78-4.26c.31-2.84-3.52-3.89-4.32-1.3-.12.37-.25.8-.25,1.3h4.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ-3",
    "data-name": "aJ",
    className: "cls-3-pm-3",
    d: "m72.8,232.65c-.8,1.85-2.28,3.27-5.06,3.21-3.7-.12-5.49-2.28-5.49-6.17s1.85-6.05,5.56-6.05,5.12,2.78,5.19,6.67h-7.53c0,1.91.49,3.4,2.41,3.46,1.11,0,1.85-.43,2.1-1.36l2.84.25Zm-2.78-4.26c.31-2.84-3.52-3.89-4.32-1.3-.12.37-.25.8-.25,1.3h4.57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aQ",
    className: "cls-3-pm-3",
    d: "m81.38,220.31c5.74.06,12.72-.99,12.59,4.88-.06,4.63-4.26,5.43-9.38,5.06v5.37h-3.21v-15.31Zm3.21,7.47c2.9,0,6.17.43,6.17-2.53s-3.33-2.41-6.17-2.41v4.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aR",
    className: "cls-3-pm-3",
    d: "m101.75,225.92c-3.64,0-2.1,5.99-2.41,9.69h-3.09v-16.11h3.09l-.06,6.73c.74-1.6,1.73-2.53,3.77-2.59,5.31-.06,3.58,6.98,3.89,11.98h-3.09c-.43-3.52,1.42-9.69-2.1-9.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS",
    className: "cls-3-pm-3",
    d: "m116.44,233.52c-.99,1.17-1.85,2.41-3.95,2.35-2.28-.06-3.58-1.23-3.58-3.58-.06-3.7,3.4-3.89,7.16-3.77.06-1.6-.19-2.9-1.73-2.9-1.11.06-1.6.56-1.73,1.67l-3.21-.12c.43-2.35,2.22-3.58,5.06-3.52s4.57,1.36,4.63,4.2l.06,5.06c-.06.86.74,1.11,1.54.93v1.67c-1.85.49-4.38.31-4.26-1.98Zm-2.96.19c1.79,0,2.65-1.48,2.59-3.52-1.98,0-4.07-.19-4.01,1.85,0,1.05.49,1.67,1.42,1.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aT",
    className: "cls-3-pm-3",
    d: "m129.03,227.1c.06-1.79-4.32-2.1-4.38-.25.93,2.84,7.28.43,7.35,5.31.06,5.12-10.12,4.69-10.62.56l2.65-.43c.25,1.17,1.23,1.54,2.72,1.54,2.04.49,3.52-1.85,1.48-2.53-2.65-.86-6.3-.68-6.42-4.07-.12-4.94,9.51-4.57,9.94-.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ-4",
    "data-name": "aJ",
    className: "cls-3-pm-3",
    d: "m144.34,232.65c-.8,1.85-2.28,3.27-5.06,3.21-3.7-.12-5.49-2.28-5.49-6.17s1.85-6.05,5.56-6.05,5.12,2.78,5.19,6.67h-7.53c0,1.91.49,3.4,2.41,3.46,1.11,0,1.85-.43,2.1-1.36l2.84.25Zm-2.78-4.26c.31-2.84-3.52-3.89-4.32-1.3-.12.37-.25.8-.25,1.3h4.57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aU",
    className: "cls-3-pm-3",
    d: "m162.67,224.38c0,4.81-5.19,5.31-6.85,8.7h7.1v2.53h-10.74c-.37-6.23,6.11-6.17,7.41-11.11.06-1.36-.74-1.91-2.04-1.98-1.42,0-1.98.86-2.16,2.1l-3.02-.19c.31-2.78,1.98-4.32,5.19-4.32s5.12,1.36,5.12,4.26"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25-pm-3",
    d: "m1002.9,191.22c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6h0v86.67c0,3.31-2.69,6-6,6h-330.26c-3.31,0-6-2.69-6-6v-86.67Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aV",
    className: "cls-13-pm-3",
    d: "m1053.06,223.69l-8.96-14.33.07,14.33h-1.97v-16.84h2.65l9.03,14.46-.14-14.46h2.1v16.84h-2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-6",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m1064.54,210.51c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aW",
    className: "cls-13-pm-3",
    d: "m1085.31,223.69h-2.44l-2.72-11.14-2.78,11.14h-2.44l-3.67-12.9h2.17l2.65,11.14,2.92-11.14h2.31l2.78,11.14,2.85-11.14h2.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aX",
    className: "cls-13-pm-3",
    d: "m1097.74,206.85c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84Zm2.24,8.49c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aY",
    className: "cls-13-pm-3",
    d: "m1114.04,206.85c8.01-.48,14.67.54,14.46,8.28-.2,5.3-2.92,8.56-8.22,8.56h-6.25v-16.84Zm2.24,15.01c6.04.54,9.91-1.09,9.91-6.72s-4.07-6.86-9.91-6.45v13.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aZ",
    className: "cls-13-pm-3",
    d: "m1133.86,208.75v6.25h9.37v1.9h-9.37v6.79h-2.24v-16.84h11.88v1.9h-9.64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ba",
    className: "cls-13-pm-3",
    d: "m1158.1,207.8c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-2",
    "data-name": "ao",
    className: "cls-13-pm-3",
    d: "m1165.78,212.62c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-3",
    "data-name": "ar",
    className: "cls-13-pm-3",
    d: "m1172.91,210.51c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-3",
    "data-name": "ax",
    className: "cls-13-pm-3",
    d: "m1193.96,212.21c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "an-5",
    "data-name": "an",
    className: "cls-13-pm-3",
    d: "m1216.36,221.24c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-2",
    "data-name": "az",
    className: "cls-13-pm-3",
    d: "m1232.39,210.78c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04Zm-5.64,11.41c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-7",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m1240.74,210.51c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-4",
    "data-name": "ay",
    className: "cls-13-pm-3",
    d: "m1255.48,210.51c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-2",
    "data-name": "av",
    className: "cls-13-pm-3",
    d: "m1267.63,212.21c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb",
    className: "cls-13-pm-3",
    d: "m1285.49,210.78l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bc",
    className: "cls-13-pm-3",
    d: "m1308.23,223.55c-1.9.68-4.21,0-5.23-1.22-2.72,2.65-10.12,2.17-9.78-3.06.2-2.92,1.97-4.14,4.07-5.16-1.7-2.72-1.15-7.74,3.19-7.33,2.38.2,4.01,1.02,4.01,3.4,0,2.99-2.72,3.6-4.82,4.69.95,1.77,2.17,3.4,3.46,4.89.95-1.43,1.63-2.92,2.04-4.89l1.77.54c-.61,2.24-1.43,3.87-2.58,5.57.88.88,2.24,1.49,3.87,1.02v1.56Zm-9.3-10.12c1.7-.68,3.53-1.22,3.8-3.26-.07-1.22-.88-1.97-2.24-1.97-2.85,0-2.65,3.4-1.56,5.23Zm-3.73,5.77c-.2,3.46,4.82,3.94,6.65,1.9-1.36-1.63-2.78-3.46-3.8-5.43-1.56.68-2.72,1.63-2.85,3.53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    id: "av-3",
    "data-name": "av",
    className: "cls-13-pm-3",
    d: "m1027.6,241.54c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-2",
    "data-name": "aq",
    className: "cls-13-pm-3",
    d: "m1040.5,241.54c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-8",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m1053.67,239.85c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-4",
    "data-name": "av",
    className: "cls-13-pm-3",
    d: "m1066.98,241.54c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw-2",
    "data-name": "aw",
    className: "cls-13-pm-3",
    d: "m1082.4,253.02l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aB-3",
    "data-name": "aB",
    className: "cls-13-pm-3",
    d: "m1093.33,237.33v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba-2",
    "data-name": "ba",
    className: "cls-13-pm-3",
    d: "m1103.92,237.13c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aB-4",
    "data-name": "aB",
    className: "cls-13-pm-3",
    d: "m1112.27,237.33v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-5",
    "data-name": "au",
    className: "cls-13-pm-3",
    d: "m1120.01,249.83c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ax-4",
    "data-name": "ax",
    className: "cls-13-pm-3",
    d: "m1143.85,241.54c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-9",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m1156.68,239.85c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-10",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m1170.26,239.85c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-6",
    "data-name": "au",
    className: "cls-13-pm-3",
    d: "m1181.06,249.83c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-3",
    "data-name": "at",
    className: "cls-13-pm-3",
    d: "m1193.01,243.31c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ap-11",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m1209.64,239.85c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bd",
    className: "cls-13-pm-3",
    d: "m1226.01,253.02l-3.46-5.3-3.53,5.3h-2.31l4.62-6.65-4.41-6.25h2.38l3.26,5.02,3.19-5.02h2.38l-4.35,6.25,4.62,6.65h-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "be",
    className: "cls-13-pm-3",
    d: "m1236.46,239.85c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31Zm-.54,11.81c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-12",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m1249.02,239.85c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-5",
    "data-name": "av",
    className: "cls-13-pm-3",
    d: "m1262.33,241.54c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-7",
    "data-name": "au",
    className: "cls-13-pm-3",
    d: "m1272.04,249.83c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-6",
    "data-name": "an",
    className: "cls-13-pm-3",
    d: "m1284.4,250.57c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-8",
    "data-name": "au",
    className: "cls-13-pm-3",
    d: "m1292.41,249.83c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-5",
    "data-name": "aB",
    className: "cls-13-pm-3",
    d: "m1296.83,237.33v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-4",
    "data-name": "ar",
    className: "cls-13-pm-3",
    d: "m1307.35,239.85c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-5",
    "data-name": "ay",
    className: "cls-13-pm-3",
    d: "m1322.09,239.85c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-23-pm-3",
    d: "m264.16,232.08h-50.76v-1h50.76v1Zm200.1,0h-38.9v-1h38.9v1Zm3.5,0h-3.5v-1h3.5v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17-pm-3",
    d: "m212.9,236.22l-14.26-4.64,14.26-4.64v9.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23-pm-3",
    d: "m213.4,236.9l-16.38-5.32,16.38-5.33v10.65Zm-13.14-5.32l12.14,3.94v-7.9l-12.14,3.96Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bf",
    className: "cls-13-pm-3",
    d: "m321.71,209.98c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02Zm-11.14,2.72c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg",
    className: "cls-13-pm-3",
    d: "m335.56,218.54c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bh",
    className: "cls-13-pm-3",
    d: "m345.27,221.8h-4.01l-4.62-12.9h3.6l3.06,10.19,3.26-10.19h3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bi",
    className: "cls-13-pm-3",
    d: "m351.86,206.59v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bj",
    className: "cls-13-pm-3",
    d: "m366.25,212.43c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg-2",
    "data-name": "bg",
    className: "cls-13-pm-3",
    d: "m383.09,218.54c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bk",
    className: "cls-13-pm-3",
    d: "m273.19,248.82c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17Zm-3.26.2c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bl",
    className: "cls-13-pm-3",
    d: "m286.91,237.96c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bm",
    className: "cls-13-pm-3",
    d: "m298.59,237.96c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72Zm1.15,11.14c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bf-2",
    "data-name": "bf",
    className: "cls-13-pm-3",
    d: "m330.57,239.32c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02Zm-11.14,2.72c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg-3",
    "data-name": "bg",
    className: "cls-13-pm-3",
    d: "m344.42,247.87c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bj-2",
    "data-name": "bj",
    className: "cls-13-pm-3",
    d: "m354.74,241.76c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bn",
    className: "cls-13-pm-3",
    d: "m364.79,251.4c-5.91.07-3.94-7.67-4.28-13.17h3.4c.48,3.87-1.56,10.19,2.24,10.66,4.07-.34,2.38-6.59,2.72-10.66h3.4l.07,12.9h-3.19c-.14-.81.07-1.9-.2-2.58-.81,1.7-1.9,2.85-4.14,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo",
    className: "cls-13-pm-3",
    d: "m383.06,237.96c3.53,0,4.75,2.92,4.75,6.65s-1.29,6.72-4.96,6.79c-2.04.07-3.12-1.02-3.94-2.38l-.14,2.1h-3.26l.07-17.72h3.4v7.06c.75-1.56,1.97-2.51,4.07-2.51Zm-1.43,11.14c2.1,0,2.72-1.83,2.72-4.48s-.48-4.28-2.65-4.28-2.78,1.9-2.78,4.41.54,4.35,2.72,4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bp",
    className: "cls-13-pm-3",
    d: "m403.7,240.47c-3.6.61-1.9,6.79-2.31,10.66h-3.33v-7.27c.07-1.83-.34-3.33-1.97-3.4-3.6.68-1.83,6.79-2.24,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.68-3.6,6.86-3.8,7.33,0,.88-1.49,1.63-2.92,4.01-2.85,5.57.07,3.46,7.88,3.87,13.17h-3.33v-7.27c-.07-1.7-.34-3.26-1.97-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bi-2",
    "data-name": "bi",
    className: "cls-13-pm-3",
    d: "m412.19,235.92v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq",
    className: "cls-13-pm-3",
    d: "m425.09,250.93c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19-pm-3",
    d: "m986.02,234.06v1h-21.26v-1h21.26Zm-191.82-1.98v-1h16.1v1h-16.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19-pm-3",
    d: "m794.22,232.08h-3.52v-1h3.52v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11-pm-3",
    d: "m1000.78,234.56l-14.26,4.63v-9.27l14.26,4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19-pm-3",
    d: "m1002.4,234.56l-16.38,5.32v-10.66l16.38,5.34Zm-15.38,3.94l12.15-3.94-12.14-3.95v7.89Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "br",
    className: "cls-13-pm-3",
    d: "m844.18,221.8l-1.49-4.28h-6.38l-1.49,4.28h-3.53l6.11-16.84h4.14l6.11,16.84h-3.46Zm-2.24-6.93l-2.44-7.33c-.68,2.58-1.63,4.89-2.44,7.33h4.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bs",
    className: "cls-13-pm-3",
    d: "m857.42,208.63c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38Zm-1.43,11.14c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bs-2",
    "data-name": "bs",
    className: "cls-13-pm-3",
    d: "m872.29,208.63c3.6,0,4.75,2.99,4.75,6.65s-1.29,6.65-4.96,6.79c-2.1.07-3.06-1.15-4.01-2.31.2,2.24.14,4.69.14,7.13h-3.4l-.07-17.99h3.26c.14.68,0,1.56.2,2.1.75-1.63,1.97-2.38,4.07-2.38Zm-1.43,11.14c2.24,0,2.65-2.1,2.72-4.48,0-2.58-.61-4.35-2.72-4.35-3.8,0-3.73,8.83,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt",
    className: "cls-13-pm-3",
    d: "m887.16,211.61c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu",
    className: "cls-13-pm-3",
    d: "m894.97,208.63c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72Zm-.07,11.14c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bh-2",
    "data-name": "bh",
    className: "cls-13-pm-3",
    d: "m911.06,221.8h-4.01l-4.62-12.9h3.6l3.06,10.19,3.26-10.19h3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg-4",
    "data-name": "bg",
    className: "cls-13-pm-3",
    d: "m928.52,218.54c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bm-2",
    "data-name": "bm",
    className: "cls-13-pm-3",
    d: "m935.51,208.63c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72Zm1.15,11.14c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bv",
    className: "cls-13-pm-3",
    d: "m825.98,251.13h-3.53l-2.65-10.52-2.72,10.52h-3.53l-3.33-12.9h3.12l2.17,9.85c.61-3.53,1.63-6.59,2.44-9.85h3.6l2.51,9.85,2.17-9.85h3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bi-3",
    "data-name": "bi",
    className: "cls-13-pm-3",
    d: "m831.01,235.92v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq-2",
    "data-name": "bq",
    className: "cls-13-pm-3",
    d: "m843.91,250.93c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bw",
    className: "cls-13-pm-3",
    d: "m851.92,240.47c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bx",
    className: "cls-13-pm-3",
    d: "m878.74,246.86c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bw-2",
    "data-name": "bw",
    className: "cls-13-pm-3",
    d: "m887.16,240.47c-4.01,0-2.31,6.59-2.65,10.66h-3.4v-17.72h3.4l-.07,7.4c.81-1.77,1.9-2.78,4.14-2.85,5.84-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bk-2",
    "data-name": "bk",
    className: "cls-13-pm-3",
    d: "m903.32,248.82c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17Zm-3.26.2c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bl-2",
    "data-name": "bl",
    className: "cls-13-pm-3",
    d: "m917.04,237.96c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "by",
    className: "cls-13-pm-3",
    d: "m935.98,250.73c.75,5.98-8.15,7.2-11.14,3.53-.27-.41-.41-.88-.54-1.43l3.33-.41c.2,1.09,1.09,1.63,2.31,1.7,2.72,0,2.85-2.51,2.72-5.36-.75,1.49-2.04,2.38-4.14,2.38-3.6,0-4.75-2.92-4.75-6.59s1.22-6.52,4.96-6.59c2.04,0,3.12.95,4.01,2.31l.14-2.04h3.19l-.07,12.49Zm-6.11-1.97c2.17,0,2.78-1.83,2.78-4.28s-.61-4.21-2.72-4.21-2.65,1.97-2.72,4.28c0,2.44.61,4.21,2.65,4.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg-5",
    "data-name": "bg",
    className: "cls-13-pm-3",
    d: "m950.18,247.87c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bj-3",
    "data-name": "bj",
    className: "cls-13-pm-3",
    d: "m960.5,241.76c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19-pm-3",
    d: "m629.73,351.52l-.04.3-.16.32-.25.25-.3.15-.27.04-.1.02-.03.02-.03.02-.02.02v22.27h-1v-22.27l.04-.3.15-.3.25-.25.3-.16.27-.04.1-.02h.03l.02-.04v-.02l.02-.07v-3.43h1l.02,3.49Zm0-24.83h-1v-13.3h1v13.3Zm0-13.3h-1v-3.5h1v3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11-pm-3",
    d: "m628.03,389.69l-4.64-14.27h9.27l-4.63,14.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19-pm-3",
    d: "m628.03,391.31l-5.32-16.4h10.64l-5.32,16.4Zm-3.95-15.4l3.95,12.15,3.95-12.15h-7.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bz",
    className: "cls-15-pm-3",
    d: "m534.2,340.91l-1.09-3.11h-4.64l-1.09,3.11h-2.57l4.44-12.25h3.01l4.44,12.25h-2.52Zm-1.63-5.04l-1.78-5.33c-.49,1.88-1.19,3.56-1.78,5.33h3.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bA",
    className: "cls-15-pm-3",
    d: "m543.83,331.33c2.62,0,3.46,2.17,3.46,4.84s-.94,4.84-3.6,4.94c-1.53.05-2.22-.84-2.91-1.68.15,1.63.1,3.41.1,5.19h-2.47l-.05-13.09h2.37c.1.49,0,1.14.15,1.53.54-1.19,1.43-1.73,2.96-1.73Zm-1.04,8.1c1.63,0,1.93-1.53,1.98-3.26,0-1.88-.44-3.16-1.98-3.16-2.77,0-2.72,6.42,0,6.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bA-2",
    "data-name": "bA",
    className: "cls-15-pm-3",
    d: "m554.65,331.33c2.62,0,3.46,2.17,3.46,4.84s-.94,4.84-3.6,4.94c-1.53.05-2.22-.84-2.91-1.68.15,1.63.1,3.41.1,5.19h-2.47l-.05-13.09h2.37c.1.49,0,1.14.15,1.53.54-1.19,1.43-1.73,2.96-1.73Zm-1.04,8.1c1.63,0,1.93-1.53,1.98-3.26,0-1.88-.44-3.16-1.98-3.16-2.77,0-2.72,6.42,0,6.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB",
    className: "cls-15-pm-3",
    d: "m565.46,333.5c-1.93-.59-2.96.64-2.96,2.81v4.59h-2.47l-.05-9.38h2.32c.1.64-.05,1.43.15,1.98.3-1.38,1.33-2.62,3.01-2.02v2.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bC",
    className: "cls-15-pm-3",
    d: "m571.14,331.33c3.16,0,4.74,1.78,4.74,4.89s-1.73,4.89-4.79,4.89-4.69-1.78-4.69-4.89,1.68-4.89,4.74-4.89Zm-.05,8.1c1.73,0,2.22-1.38,2.22-3.21,0-1.98-.49-3.21-2.12-3.21s-2.22,1.28-2.22,3.21c0,1.78.49,3.21,2.12,3.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bD",
    className: "cls-15-pm-3",
    d: "m582.84,340.91h-2.91l-3.36-9.38h2.62l2.22,7.41,2.37-7.41h2.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bE",
    className: "cls-15-pm-3",
    d: "m595.53,338.54c-.64,1.48-1.83,2.62-4.05,2.57-2.96-.1-4.4-1.83-4.4-4.94s1.48-4.84,4.44-4.84,4.1,2.22,4.15,5.33h-6.02c0,1.53.4,2.72,1.93,2.77.89,0,1.48-.35,1.68-1.09l2.27.2Zm-2.22-3.41c.25-2.27-2.81-3.11-3.46-1.04-.1.3-.2.64-.2,1.04h3.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bF",
    className: "cls-15-pm-3",
    d: "m600.62,331.33c1.53-.05,2.27.74,2.86,1.68l-.05-4.99h2.47l.05,12.89h-2.37c-.1-.49,0-1.14-.15-1.53-.54,1.14-1.43,1.73-3.01,1.73-2.57,0-3.36-2.22-3.41-4.89,0-2.77.94-4.79,3.6-4.89Zm.84,8.1c1.63,0,1.98-1.48,2.02-3.26.05-1.83-.44-3.16-2.02-3.16s-1.88,1.48-1.93,3.21c0,2.12.64,3.21,1.93,3.21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bG",
    className: "cls-15-pm-3",
    d: "m618,329.75c-1.33-.35-2.12.25-1.88,1.78h1.88v1.63h-1.88v7.75h-2.42v-7.75h-1.38v-1.63h1.38c-.44-2.91,1.58-4,4.3-3.36v1.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bC-2",
    "data-name": "bC",
    className: "cls-15-pm-3",
    d: "m623.34,331.33c3.16,0,4.74,1.78,4.74,4.89s-1.73,4.89-4.79,4.89-4.69-1.78-4.69-4.89,1.68-4.89,4.74-4.89Zm-.05,8.1c1.73,0,2.22-1.38,2.22-3.21,0-1.98-.49-3.21-2.12-3.21s-2.22,1.28-2.22,3.21c0,1.78.49,3.21,2.12,3.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB-2",
    "data-name": "bB",
    className: "cls-15-pm-3",
    d: "m635.39,333.5c-1.93-.59-2.96.64-2.96,2.81v4.59h-2.47l-.05-9.38h2.32c.1.64-.05,1.43.15,1.98.3-1.38,1.33-2.62,3.01-2.02v2.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bH",
    className: "cls-15-pm-3",
    d: "m641.76,328.66c4.59.05,10.17-.79,10.07,3.9-.05,3.7-3.41,4.35-7.51,4.05v4.3h-2.57v-12.25Zm2.57,5.98c2.32,0,4.94.35,4.94-2.02s-2.67-1.93-4.94-1.93v3.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB-3",
    "data-name": "bB",
    className: "cls-15-pm-3",
    d: "m659.09,333.5c-1.93-.59-2.96.64-2.96,2.81v4.59h-2.47l-.05-9.38h2.32c.1.64-.05,1.43.15,1.98.3-1.38,1.33-2.62,3.01-2.02v2.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bC-3",
    "data-name": "bC",
    className: "cls-15-pm-3",
    d: "m664.77,331.33c3.16,0,4.74,1.78,4.74,4.89s-1.73,4.89-4.79,4.89-4.69-1.78-4.69-4.89,1.68-4.89,4.74-4.89Zm-.05,8.1c1.73,0,2.22-1.38,2.22-3.21,0-1.98-.49-3.21-2.12-3.21s-2.22,1.28-2.22,3.21c0,1.78.49,3.21,2.12,3.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bF-2",
    "data-name": "bF",
    className: "cls-15-pm-3",
    d: "m674.5,331.33c1.53-.05,2.27.74,2.86,1.68l-.05-4.99h2.47l.05,12.89h-2.37c-.1-.49,0-1.14-.15-1.53-.54,1.14-1.43,1.73-3.01,1.73-2.57,0-3.36-2.22-3.41-4.89,0-2.77.94-4.79,3.6-4.89Zm.84,8.1c1.63,0,1.98-1.48,2.02-3.26.05-1.83-.44-3.16-2.02-3.16s-1.88,1.48-1.93,3.21c0,2.12.64,3.21,1.93,3.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bI",
    className: "cls-15-pm-3",
    d: "m685.16,341.11c-4.3.05-2.86-5.58-3.11-9.58h2.47c.35,2.81-1.14,7.41,1.63,7.75,2.96-.25,1.73-4.79,1.98-7.75h2.47l.05,9.38h-2.32c-.1-.59.05-1.38-.15-1.88-.59,1.23-1.38,2.07-3.01,2.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bJ",
    className: "cls-15-pm-3",
    d: "m701.16,337.8c-.35,2.07-1.88,3.31-4.25,3.31-2.91,0-4.15-1.88-4.44-4.84-.59-5.43,7.6-6.77,8.59-1.78l-2.42.1c-.1-.94-.74-1.58-1.73-1.58-1.48,0-1.73,1.38-1.88,3.16-.3,3.65,3.21,4.3,3.65,1.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bK",
    className: "cls-15-pm-3",
    d: "m707.34,340.76c-1.78.69-4.3.35-4.3-2.07v-5.53h-1.19v-1.63h1.33l.74-2.22h1.53v2.22h1.78v1.63h-1.78v4.89c-.05,1.14.79,1.53,1.88,1.23v1.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bL",
    className: "cls-15-pm-3",
    d: "m708.77,329.85v-1.83h2.47v1.83h-2.47Zm0,11.06v-9.38h2.47v9.38h-2.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bC-4",
    "data-name": "bC",
    className: "cls-15-pm-3",
    d: "m717.91,331.33c3.16,0,4.74,1.78,4.74,4.89s-1.73,4.89-4.79,4.89-4.69-1.78-4.69-4.89,1.68-4.89,4.74-4.89Zm-.05,8.1c1.73,0,2.22-1.38,2.22-3.21,0-1.98-.49-3.21-2.12-3.21s-2.22,1.28-2.22,3.21c0,1.78.49,3.21,2.12,3.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bM",
    className: "cls-15-pm-3",
    d: "m729.95,331.33c4.3-.05,2.86,5.58,3.11,9.58h-2.47c-.35-2.81,1.14-7.75-1.68-7.75s-1.68,4.79-1.93,7.75h-2.47l-.05-9.38h2.32c.1.59-.05,1.38.15,1.88.59-1.28,1.38-2.02,3.01-2.07"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rect2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-pm-3",
    d: "m455.26,397.81c-.01-3.31,2.67-6.01,5.98-6.02,0,0,.01,0,.02,0h330.26c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6h-330.26c-3.31,0-6-2.69-6-6v-86.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aX-2",
    "data-name": "aX",
    className: "cls-13-pm-3",
    d: "m570.48,430.11c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84Zm2.24,8.49c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-3",
    "data-name": "ao",
    className: "cls-13-pm-3",
    d: "m592.48,435.89c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-5",
    "data-name": "ar",
    className: "cls-13-pm-3",
    d: "m599.61,433.78c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bN",
    className: "cls-13-pm-3",
    d: "m612.17,433.78c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79Zm.61,1.63c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-2",
    "data-name": "as",
    className: "cls-13-pm-3",
    d: "m625.68,447.23c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-6",
    "data-name": "av",
    className: "cls-13-pm-3",
    d: "m640.07,435.48c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-9",
    "data-name": "au",
    className: "cls-13-pm-3",
    d: "m649.78,443.76c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-6",
    "data-name": "aB",
    className: "cls-13-pm-3",
    d: "m654.2,431.27v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-6",
    "data-name": "ar",
    className: "cls-13-pm-3",
    d: "m664.72,433.78c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-6",
    "data-name": "ay",
    className: "cls-13-pm-3",
    d: "m679.46,433.78c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "diamond2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9-pm-3",
    d: "m621.01,689.06c3.39-1.67,7.37-1.67,10.76,0l160.38,79.02c1.46.73,2.06,2.51,1.33,3.97-.29.58-.75,1.04-1.33,1.33l-160.39,79.04c-3.39,1.67-7.36,1.67-10.75,0l-160.35-79.04c-1.46-.73-2.06-2.51-1.33-3.97.29-.58.75-1.04,1.33-1.33l160.35-79.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "I"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bO",
    className: "cls-3-pm-3",
    d: "m515.66,767.07c0,3.6,1.43,5.91,4.96,5.98,2.51.07,3.67-1.49,4.41-3.19l3.06,1.15c-1.15,2.85-3.46,4.82-7.47,4.82-5.57,0-8.15-3.12-8.49-8.76-.48-7.47,7.4-10.59,13.31-7.27,1.22.68,1.97,1.97,2.44,3.4l-3.12.81c-.54-1.7-2.04-2.78-4.21-2.78-3.53,0-4.82,2.31-4.89,5.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ-5",
    "data-name": "aJ",
    className: "cls-3-pm-3",
    d: "m541.26,772.3c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aK-2",
    "data-name": "aK",
    className: "cls-3-pm-3",
    d: "m551.44,765.37c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aO-2",
    "data-name": "aO",
    className: "cls-3-pm-3",
    d: "m559.59,775.35c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aM-2",
    "data-name": "aM",
    className: "cls-3-pm-3",
    d: "m561.56,760.35v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bP",
    className: "cls-3-pm-3",
    d: "m574.87,760.21c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aM-3",
    "data-name": "aM",
    className: "cls-3-pm-3",
    d: "m576.43,760.35v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aN-2",
    "data-name": "aN",
    className: "cls-3-pm-3",
    d: "m594.43,771.28c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aS-2",
    "data-name": "aS",
    className: "cls-3-pm-3",
    d: "m604.14,773.25c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17Zm-3.26.2c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aO-3",
    "data-name": "aO",
    className: "cls-3-pm-3",
    d: "m616.49,775.35c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aM-4",
    "data-name": "aM",
    className: "cls-3-pm-3",
    d: "m618.46,760.35v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bQ",
    className: "cls-3-pm-3",
    d: "m631.02,762.38c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72Zm-.07,11.14c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bR",
    className: "cls-3-pm-3",
    d: "m647.59,762.38c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "J"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aI-2",
    "data-name": "aI",
    className: "cls-3-pm-3",
    d: "m670.07,775.56h-3.6l-6.25-16.84h3.73l4.35,13.99c1.15-4.89,2.85-9.3,4.28-13.99h3.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aJ-6",
    "data-name": "aJ",
    className: "cls-3-pm-3",
    d: "m687.59,772.3c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aK-3",
    "data-name": "aK",
    className: "cls-3-pm-3",
    d: "m697.77,765.37c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aL-2",
    "data-name": "aL",
    className: "cls-3-pm-3",
    d: "m704.09,762.38c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72Zm1.15,11.14c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aM-5",
    "data-name": "aM",
    className: "cls-3-pm-3",
    d: "m714.68,760.35v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aN-3",
    "data-name": "aN",
    className: "cls-3-pm-3",
    d: "m732.67,771.28c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aO-4",
    "data-name": "aO",
    className: "cls-3-pm-3",
    d: "m741.16,775.35c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-24-pm-3",
    d: "m623.62,638.77l1.88,34.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19-pm-3",
    d: "m624.12,638.76l-1,.05-.02-.55h1l.02.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20-pm-3",
    d: "m626.3,687.82l-5.4-14,9.25-.5-3.85,14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19-pm-3",
    d: "m99.01,766.08l.07.88.2.84.33.8.45.73.56.67.66.56.73.45.8.33.84.2.87.08h165.86v1H104.49l-1-.08-1-.24-.93-.4-.87-.52-.78-.66-.66-.78-.54-.87-.4-.94-.23-1-.08-1v-468.32h1v468.27Zm359.83,5.52v1h-46.26v-1h46.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11-pm-3",
    d: "m459.29,772.02l.34.55-.8.03v-1h.3l.16.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19-pm-3",
    d: "m459.31,772l.37.6-.88.02v-1.05h.36l.15.43Zm-.46-.38v.95l.73-.03-.33-.52-.13-.4h-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11-pm-3",
    d: "m103.14,297.29h-9.28l4.65-14.26,4.63,14.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19-pm-3",
    d: "m103.83,297.79h-10.64l5.32-16.38,5.32,16.38Zm-9.27-1h7.9l-3.95-12.14-3.95,12.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "K"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bS",
    className: "cls-13-pm-3",
    d: "m282.28,776.99l-7.33-12.97c.41,3.94.14,8.69.2,12.97h-3.12v-16.84h4.01l7.47,13.1c-.41-3.94-.14-8.76-.2-13.1h3.12v16.84h-4.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bu-2",
    "data-name": "bu",
    className: "cls-13-pm-3",
    d: "m295.45,763.82c4.35,0,6.52,2.44,6.52,6.72s-2.38,6.72-6.59,6.72-6.45-2.44-6.45-6.72,2.31-6.72,6.52-6.72Zm-.07,11.14c2.38,0,3.06-1.9,3.06-4.41,0-2.72-.68-4.41-2.92-4.41s-3.06,1.77-3.06,4.41c0,2.44.68,4.41,2.92,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq-3",
    "data-name": "bq",
    className: "cls-13-pm-3",
    d: "m310.66,776.78c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "L"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bx-2",
    "data-name": "bx",
    className: "cls-13-pm-3",
    d: "m330.63,772.71c-.48,2.85-2.58,4.55-5.84,4.55-4.01,0-5.7-2.58-6.11-6.65-.81-7.47,10.46-9.3,11.81-2.44l-3.33.14c-.14-1.29-1.02-2.17-2.38-2.17-2.04,0-2.38,1.9-2.58,4.35-.41,5.02,4.41,5.91,5.02,2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg-6",
    "data-name": "bg",
    className: "cls-13-pm-3",
    d: "m343.87,773.73c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bt-2",
    "data-name": "bt",
    className: "cls-13-pm-3",
    d: "m354.05,766.8c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq-4",
    "data-name": "bq",
    className: "cls-13-pm-3",
    d: "m362.2,776.78c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bi-4",
    "data-name": "bi",
    className: "cls-13-pm-3",
    d: "m364.17,761.78v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bT",
    className: "cls-13-pm-3",
    d: "m377.48,761.64c-1.83-.48-2.92.34-2.58,2.44h2.58v2.24h-2.58v10.66h-3.33v-10.66h-1.9v-2.24h1.9c-.61-4.01,2.17-5.5,5.91-4.62v2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bi-5",
    "data-name": "bi",
    className: "cls-13-pm-3",
    d: "m379.04,761.78v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg-7",
    "data-name": "bg",
    className: "cls-13-pm-3",
    d: "m396.69,773.73c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bm-3",
    "data-name": "bm",
    className: "cls-13-pm-3",
    d: "m403.69,763.82c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72Zm1.15,11.14c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rect4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-pm-3",
    d: "m455.26,933.52c0-3.31,2.69-6,6-6h330.26c3.31,0,6,2.69,6,6v86.66c0,3.31-2.69,6-6,6h-330.26c-3.31,0-6-2.69-6-6v-86.66Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "M"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aZ-2",
    "data-name": "aZ",
    className: "cls-13-pm-3",
    d: "m483.36,967.72v6.25h9.37v1.9h-9.37v6.79h-2.24v-16.84h11.88v1.9h-9.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-7",
    "data-name": "aB",
    className: "cls-13-pm-3",
    d: "m495.58,966.98v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-7",
    "data-name": "ay",
    className: "cls-13-pm-3",
    d: "m507.26,969.49c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-7",
    "data-name": "an",
    className: "cls-13-pm-3",
    d: "m522.47,980.22c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bU",
    className: "cls-13-pm-3",
    d: "m528.11,982.66v-17.72h2.17v17.72h-2.17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "N"
  }, /*#__PURE__*/React.createElement("path", {
    id: "at-4",
    "data-name": "at",
    className: "cls-13-pm-3",
    d: "m547.8,972.95c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-10",
    "data-name": "au",
    className: "cls-13-pm-3",
    d: "m554.86,979.47c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-13",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m564.43,969.49c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "be-2",
    "data-name": "be",
    className: "cls-13-pm-3",
    d: "m579.03,969.49c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31Zm-.54,11.81c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-5",
    "data-name": "at",
    className: "cls-13-pm-3",
    d: "m593.97,972.95c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "O"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bV",
    className: "cls-13-pm-3",
    d: "m611.62,969.49c3.6,0,4.69,2.65,4.75,6.65,0,4.48-1.56,6.79-4.75,6.79-2.1-.07-3.33-.75-4.01-2.31l-.14,2.04h-2.1l.07-17.72h2.17v6.86c.68-1.56,1.9-2.31,4.01-2.31Zm-.54,11.81c2.72,0,3.06-2.31,3.06-5.09s-.34-5.09-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-14",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m624.19,969.49c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba-3",
    "data-name": "ba",
    className: "cls-13-pm-3",
    d: "m637.83,966.77c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-7",
    "data-name": "ar",
    className: "cls-13-pm-3",
    d: "m644.56,969.49c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-4",
    "data-name": "ao",
    className: "cls-13-pm-3",
    d: "m659.09,971.59c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-15",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m666.22,969.49c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "P"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bW",
    className: "cls-13-pm-3",
    d: "m682.99,971.12h-1.7l-.27-5.3h2.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bX",
    className: "cls-13-pm-3",
    d: "m694.12,982.93c-5.57,0-8.22-3.26-8.49-8.76-.34-7.27,6.79-10.46,13.1-7.54,1.15.54,1.97,1.7,2.51,2.92l-2.17.61c-.88-1.7-2.51-2.72-5.16-2.72-4.14,0-5.98,2.65-5.98,6.72s1.97,6.79,6.18,6.86c2.38,0,4.21-.75,5.36-1.83v-3.06h-5.02v-1.9h7.13v5.84c-1.7,1.7-4.14,2.85-7.47,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-8",
    "data-name": "ar",
    className: "cls-13-pm-3",
    d: "m710.22,969.49c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bY",
    className: "cls-13-pm-3",
    d: "m718.09,977.09v-1.9h5.98v1.9h-5.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-2",
    "data-name": "aD",
    className: "cls-13-pm-3",
    d: "m727.12,982.66v-16.84h2.24v15.01h8.49v1.83h-10.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-8",
    "data-name": "aB",
    className: "cls-13-pm-3",
    d: "m740.3,966.98v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bZ",
    className: "cls-13-pm-3",
    d: "m751.36,982.66h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-16",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m763.04,969.49c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bW-2",
    "data-name": "bW",
    className: "cls-13-pm-3",
    d: "m773.03,971.12h-1.7l-.27-5.3h2.24"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19-pm-3",
    d: "m626.89,910.62h-1v-15.5h1v15.5Zm0-42.18h-1v-15.9h1v15.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19-pm-3",
    d: "m626.89,852.55h-1v-3.52h1v3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11-pm-3",
    d: "m626.39,925.39l-4.63-14.26h9.27l-4.64,14.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19-pm-3",
    d: "m626.39,927.02l-5.32-16.4h10.66l-5.34,16.4Zm-3.94-15.4l3.93,12.16,3.95-12.15h-7.88Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ca",
    className: "cls-15-pm-3",
    d: "m585.59,878.51c0,3.27,1.3,5.37,4.51,5.43,2.28.06,3.33-1.36,4.01-2.9l2.78,1.05c-1.05,2.59-3.15,4.38-6.79,4.38-5.06,0-7.41-2.84-7.72-7.96-.43-6.79,6.73-9.63,12.1-6.6,1.11.62,1.79,1.79,2.22,3.09l-2.84.74c-.49-1.54-1.85-2.53-3.83-2.53-3.21,0-4.38,2.1-4.44,5.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bE-2",
    "data-name": "bE",
    className: "cls-15-pm-3",
    d: "m608.87,883.26c-.8,1.85-2.28,3.27-5.06,3.21-3.7-.12-5.49-2.28-5.49-6.17s1.85-6.05,5.56-6.05,5.12,2.78,5.19,6.67h-7.53c0,1.91.49,3.4,2.41,3.46,1.11,0,1.85-.43,2.1-1.36l2.84.25Zm-2.78-4.26c.31-2.84-3.52-3.89-4.32-1.3-.12.37-.25.8-.25,1.3h4.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bB-4",
    "data-name": "bB",
    className: "cls-15-pm-3",
    d: "m618.13,876.96c-2.41-.74-3.7.8-3.7,3.52v5.74h-3.09l-.06-11.73h2.9c.12.8-.06,1.79.19,2.47.37-1.73,1.67-3.27,3.77-2.53v2.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bK-2",
    "data-name": "bK",
    className: "cls-15-pm-3",
    d: "m625.53,886.04c-2.22.86-5.37.43-5.37-2.59v-6.91h-1.48v-2.04h1.67l.93-2.78h1.91v2.78h2.22v2.04h-2.22v6.11c-.06,1.42.99,1.91,2.35,1.54v1.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bL-2",
    "data-name": "bL",
    className: "cls-15-pm-3",
    d: "m627.32,872.39v-2.28h3.09v2.28h-3.09Zm0,13.83v-11.73h3.09v11.73h-3.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bG-2",
    "data-name": "bG",
    className: "cls-15-pm-3",
    d: "m639.42,872.27c-1.67-.43-2.65.31-2.35,2.22h2.35v2.04h-2.35v9.69h-3.02v-9.69h-1.73v-2.04h1.73c-.56-3.64,1.98-5,5.37-4.2v1.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bL-3",
    "data-name": "bL",
    className: "cls-15-pm-3",
    d: "m640.84,872.39v-2.28h3.09v2.28h-3.09Zm0,13.83v-11.73h3.09v11.73h-3.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bE-3",
    "data-name": "bE",
    className: "cls-15-pm-3",
    d: "m656.89,883.26c-.8,1.85-2.28,3.27-5.06,3.21-3.7-.12-5.49-2.28-5.49-6.17s1.85-6.05,5.56-6.05,5.12,2.78,5.19,6.67h-7.53c0,1.91.49,3.4,2.41,3.46,1.11,0,1.85-.43,2.1-1.36l2.84.25Zm-2.78-4.26c.31-2.84-3.52-3.89-4.32-1.3-.12.37-.25.8-.25,1.3h4.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bF-3",
    "data-name": "bF",
    className: "cls-15-pm-3",
    d: "m663.25,874.25c1.91-.06,2.84.93,3.58,2.1l-.06-6.23h3.09l.06,16.11h-2.96c-.12-.62,0-1.42-.19-1.91-.68,1.42-1.79,2.16-3.77,2.16-3.21,0-4.2-2.78-4.26-6.11,0-3.46,1.17-5.99,4.51-6.11Zm1.05,10.12c2.04,0,2.47-1.85,2.53-4.07.06-2.28-.56-3.95-2.53-3.95s-2.35,1.85-2.41,4.01c0,2.65.8,4.01,2.41,4.01"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-24-pm-3",
    d: "m626.39,1027.18v42.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19-pm-3",
    d: "m626.89,1027.19h-1v-.5h1v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20-pm-3",
    d: "m626.39,1084.59l-4.63-14.26h9.27l-4.64,14.26Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "rect5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-pm-3",
    d: "m455.26,1091.79c0-3.31,2.69-6,6-6h330.26c3.31,0,6,2.69,6,6v86.66c0,3.31-2.69,6-6,6h-330.26c-3.31,0-6-2.69-6-6v-86.66Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "R"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aC-2",
    "data-name": "aC",
    className: "cls-13-pm-3",
    d: "m513.57,1113.12l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-8",
    "data-name": "an",
    className: "cls-13-pm-3",
    d: "m527.15,1110.68c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-11",
    "data-name": "au",
    className: "cls-13-pm-3",
    d: "m535.17,1109.93c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-17",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m544.74,1099.95c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-5",
    "data-name": "ao",
    className: "cls-13-pm-3",
    d: "m559.27,1102.06c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-9",
    "data-name": "aB",
    className: "cls-13-pm-3",
    d: "m561.24,1097.44v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-9",
    "data-name": "an",
    className: "cls-13-pm-3",
    d: "m574.55,1110.68c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bU-2",
    "data-name": "bU",
    className: "cls-13-pm-3",
    d: "m580.19,1113.12v-17.72h2.17v17.72h-2.17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "S"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bX-2",
    "data-name": "bX",
    className: "cls-13-pm-3",
    d: "m600.42,1113.4c-5.57,0-8.22-3.26-8.49-8.76-.34-7.27,6.79-10.46,13.1-7.54,1.15.54,1.97,1.7,2.51,2.92l-2.17.61c-.88-1.7-2.51-2.72-5.16-2.72-4.14,0-5.98,2.65-5.98,6.72s1.97,6.79,6.18,6.86c2.38,0,4.21-.75,5.36-1.83v-3.06h-5.02v-1.9h7.13v5.84c-1.7,1.7-4.14,2.85-7.47,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-9",
    "data-name": "ar",
    className: "cls-13-pm-3",
    d: "m616.51,1099.95c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bY-2",
    "data-name": "bY",
    className: "cls-13-pm-3",
    d: "m624.39,1107.56v-1.9h5.98v1.9h-5.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-3",
    "data-name": "aD",
    className: "cls-13-pm-3",
    d: "m633.42,1113.12v-16.84h2.24v15.01h8.49v1.83h-10.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-10",
    "data-name": "aB",
    className: "cls-13-pm-3",
    d: "m646.59,1097.44v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bZ-2",
    "data-name": "bZ",
    className: "cls-13-pm-3",
    d: "m657.66,1113.12h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-18",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m669.34,1099.95c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "T"
  }, /*#__PURE__*/React.createElement("path", {
    id: "be-3",
    "data-name": "be",
    className: "cls-13-pm-3",
    d: "m690.73,1099.95c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31Zm-.54,11.81c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-3",
    "data-name": "aq",
    className: "cls-13-pm-3",
    d: "m703.7,1101.65c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-10",
    "data-name": "an",
    className: "cls-13-pm-3",
    d: "m719.66,1110.68c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-6",
    "data-name": "at",
    className: "cls-13-pm-3",
    d: "m732.83,1103.41c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-19",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m742.67,1099.95c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cb",
    className: "cls-13-pm-3",
    d: "m751.7,1113.12v-2.58h2.31v2.58h-2.31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "U"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aA-2",
    "data-name": "aA",
    className: "cls-13-pm-3",
    d: "m484.55,1139.28v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-8",
    "data-name": "ay",
    className: "cls-13-pm-3",
    d: "m497.04,1126.11c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba-4",
    "data-name": "ba",
    className: "cls-13-pm-3",
    d: "m509.53,1123.39c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-10",
    "data-name": "ar",
    className: "cls-13-pm-3",
    d: "m516.26,1126.11c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-6",
    "data-name": "ao",
    className: "cls-13-pm-3",
    d: "m530.79,1128.21c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-5",
    "data-name": "ax",
    className: "cls-13-pm-3",
    d: "m545.39,1127.8c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "V"
  }, /*#__PURE__*/React.createElement("path", {
    id: "au-12",
    "data-name": "au",
    className: "cls-13-pm-3",
    d: "m562.23,1136.09c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-4",
    "data-name": "aq",
    className: "cls-13-pm-3",
    d: "m572.21,1127.8c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-20",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m585.38,1126.11c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "W"
  }, /*#__PURE__*/React.createElement("path", {
    id: "av-7",
    "data-name": "av",
    className: "cls-13-pm-3",
    d: "m605.48,1127.8c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as-3",
    "data-name": "as",
    className: "cls-13-pm-3",
    d: "m616.89,1139.55c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-7",
    "data-name": "at",
    className: "cls-13-pm-3",
    d: "m633.93,1129.57c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-13",
    "data-name": "au",
    className: "cls-13-pm-3",
    d: "m640.99,1136.09c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-11",
    "data-name": "ar",
    className: "cls-13-pm-3",
    d: "m650.57,1126.11c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-6",
    "data-name": "ax",
    className: "cls-13-pm-3",
    d: "m671.61,1127.8c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-21",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m684.45,1126.11c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-7",
    "data-name": "ao",
    className: "cls-13-pm-3",
    d: "m698.98,1128.21c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  })), /*#__PURE__*/React.createElement("g", {
    id: "X"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ba-5",
    "data-name": "ba",
    className: "cls-13-pm-3",
    d: "m712.97,1123.39c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-11",
    "data-name": "an",
    className: "cls-13-pm-3",
    d: "m722.47,1136.84c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-8",
    "data-name": "av",
    className: "cls-13-pm-3",
    d: "m733,1127.8c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-11",
    "data-name": "aB",
    className: "cls-13-pm-3",
    d: "m740.33,1123.59v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-9",
    "data-name": "ay",
    className: "cls-13-pm-3",
    d: "m752.01,1126.11c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "az-3",
    "data-name": "az",
    className: "cls-13-pm-3",
    d: "m769.66,1126.38c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04Zm-5.64,11.41c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "au-14",
    "data-name": "au",
    className: "cls-13-pm-3",
    d: "m600.25,1162.24c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-22",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m609.82,1152.26c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-12",
    "data-name": "an",
    className: "cls-13-pm-3",
    d: "m626.19,1162.99c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ax-7",
    "data-name": "ax",
    className: "cls-13-pm-3",
    d: "m644.45,1153.96c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cb-2",
    "data-name": "cb",
    className: "cls-13-pm-3",
    d: "m652.74,1165.44v-2.58h2.31v2.58h-2.31"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-24-pm-3",
    d: "m1174.03,284.89v132.13h-359.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19-pm-3",
    d: "m1174.53,284.9h-1v-.5h1v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20-pm-3",
    d: "m799.64,417.02l14.26-4.63v9.28l-14.26-4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24-pm-3",
    d: "m626.39,1185.45v43.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19-pm-3",
    d: "m626.89,1185.47h-1v-.52h1v.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20-pm-3",
    d: "m626.39,1243.57l-4.63-14.27h9.27l-4.64,14.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19-pm-3",
    d: "m841.36,771.24h-50v-1h50v1Zm332.23-313.57l1,.24.94.38.87.53.77.67.68.78.53.87.4.94.24,1,.08,1v300.68l-.08,1-.24.98-.4.95-.52.87-.67.77-.76.67-.87.54-.94.4-1,.24-1,.08h-92.62v-1h92.6l.88-.07.84-.2.8-.33.73-.46.66-.56.57-.65.45-.74.33-.8.2-.82.07-.88v-300.63l-.07-.9-.2-.83-.33-.8-.45-.73-.56-.66-.65-.56-.74-.45-.78-.33-.84-.2-.88-.07h-358.23v-1h358.2l.99.08Zm-382.23,313.57h-3.5v-1h3.5v1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11-pm-3",
    d: "m813.9,462.72l-14.26-4.63,14.26-4.63v9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19-pm-3",
    d: "m814.4,463.42l-16.38-5.33,16.38-5.32v10.65Zm-13.15-5.33l12.14,3.95v-7.9l-12.14,3.95Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bf-3",
    "data-name": "bf",
    className: "cls-13-pm-3",
    d: "m857.67,763.81c0,2.72-1.56,4.14-3.67,4.75l4.55,7.06h-4.01l-3.87-6.38h-4.14v6.38h-3.53v-16.84c6.31.27,14.73-1.56,14.67,5.02Zm-11.14,2.72c3.26-.14,7.6.81,7.6-2.58s-4.48-2.17-7.6-2.38v4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg-8",
    "data-name": "bg",
    className: "cls-13-pm-3",
    d: "m871.52,772.37c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bh-3",
    "data-name": "bh",
    className: "cls-13-pm-3",
    d: "m881.23,775.62h-4.01l-4.62-12.9h3.6l3.06,10.19,3.26-10.19h3.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bi-6",
    "data-name": "bi",
    className: "cls-13-pm-3",
    d: "m887.82,760.41v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bj-4",
    "data-name": "bj",
    className: "cls-13-pm-3",
    d: "m902.21,766.25c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg-9",
    "data-name": "bg",
    className: "cls-13-pm-3",
    d: "m919.05,772.37c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  })), /*#__PURE__*/React.createElement("g", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bk-3",
    "data-name": "bk",
    className: "cls-13-pm-3",
    d: "m935.89,773.32c-1.09,1.29-2.04,2.65-4.35,2.58-2.51-.07-3.94-1.36-3.94-3.94-.07-4.07,3.73-4.28,7.88-4.14.07-1.77-.2-3.19-1.9-3.19-1.22.07-1.77.61-1.9,1.83l-3.53-.14c.48-2.58,2.44-3.94,5.57-3.87s5.02,1.49,5.09,4.62l.07,5.57c-.07.95.81,1.22,1.7,1.02v1.83c-2.04.54-4.82.34-4.69-2.17Zm-3.26.2c1.97,0,2.92-1.63,2.85-3.87-2.17,0-4.48-.2-4.41,2.04,0,1.15.54,1.83,1.56,1.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bl-3",
    "data-name": "bl",
    className: "cls-13-pm-3",
    d: "m949.61,762.45c5.91-.07,3.94,7.67,4.28,13.17h-3.4c-.48-3.87,1.56-10.66-2.31-10.66s-2.31,6.59-2.65,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.81-1.77,1.9-2.78,4.14-2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bm-4",
    "data-name": "bm",
    className: "cls-13-pm-3",
    d: "m961.29,762.45c2.1-.07,3.12,1.02,3.94,2.31l-.07-6.86h3.4l.07,17.72h-3.26c-.14-.68,0-1.56-.2-2.1-.75,1.56-1.97,2.38-4.14,2.38-3.53,0-4.62-3.06-4.69-6.72,0-3.8,1.29-6.59,4.96-6.72Zm1.15,11.14c2.24,0,2.72-2.04,2.78-4.48.07-2.51-.61-4.35-2.78-4.35s-2.58,2.04-2.65,4.41c0,2.92.88,4.41,2.65,4.41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bt-3",
    "data-name": "bt",
    className: "cls-13-pm-3",
    d: "m986.14,765.44c-2.65-.81-4.07.88-4.07,3.87v6.31h-3.4l-.07-12.9h3.19c.14.88-.07,1.97.2,2.72.41-1.9,1.83-3.6,4.14-2.78v2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bg-10",
    "data-name": "bg",
    className: "cls-13-pm-3",
    d: "m999.04,772.37c-.88,2.04-2.51,3.6-5.57,3.53-4.07-.14-6.04-2.51-6.04-6.79s2.04-6.65,6.11-6.65,5.64,3.06,5.7,7.33h-8.28c0,2.1.54,3.73,2.65,3.8,1.22,0,2.04-.48,2.31-1.49l3.12.27Zm-3.06-4.69c.34-3.12-3.87-4.28-4.75-1.43-.14.41-.27.88-.27,1.43h5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bj-5",
    "data-name": "bj",
    className: "cls-13-pm-3",
    d: "m1009.36,766.25c.07-1.97-4.75-2.31-4.82-.27,1.02,3.12,8.01.48,8.08,5.84.07,5.64-11.14,5.16-11.68.61l2.92-.48c.27,1.29,1.36,1.7,2.99,1.7,2.24.54,3.87-2.04,1.63-2.78-2.92-.95-6.93-.75-7.06-4.48-.14-5.43,10.46-5.02,10.93-.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bn-2",
    "data-name": "bn",
    className: "cls-13-pm-3",
    d: "m1019.41,775.9c-5.91.07-3.94-7.67-4.28-13.17h3.4c.48,3.87-1.56,10.19,2.24,10.66,4.07-.34,2.38-6.59,2.72-10.66h3.4l.07,12.9h-3.19c-.14-.81.07-1.9-.2-2.58-.81,1.7-1.9,2.85-4.14,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bo-2",
    "data-name": "bo",
    className: "cls-13-pm-3",
    d: "m1037.68,762.45c3.53,0,4.75,2.92,4.75,6.65s-1.29,6.72-4.96,6.79c-2.04.07-3.12-1.02-3.94-2.38l-.14,2.1h-3.26l.07-17.72h3.4v7.06c.75-1.56,1.97-2.51,4.07-2.51Zm-1.43,11.14c2.1,0,2.72-1.83,2.72-4.48s-.48-4.28-2.65-4.28-2.78,1.9-2.78,4.41.54,4.35,2.72,4.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bp-2",
    "data-name": "bp",
    className: "cls-13-pm-3",
    d: "m1058.32,764.96c-3.6.61-1.9,6.79-2.31,10.66h-3.33v-7.27c.07-1.83-.34-3.33-1.97-3.4-3.6.68-1.83,6.79-2.24,10.66h-3.4l-.07-12.9h3.19c.14.81-.07,1.9.2,2.58.68-3.6,6.86-3.8,7.33,0,.88-1.49,1.63-2.92,4.01-2.85,5.57.07,3.46,7.88,3.87,13.17h-3.33v-7.27c-.07-1.7-.34-3.26-1.97-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bi-7",
    "data-name": "bi",
    className: "cls-13-pm-3",
    d: "m1066.81,760.41v-2.51h3.4v2.51h-3.4Zm0,15.21v-12.9h3.4v12.9h-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bq-5",
    "data-name": "bq",
    className: "cls-13-pm-3",
    d: "m1079.71,775.42c-2.44.95-5.91.48-5.91-2.85v-7.6h-1.63v-2.24h1.83l1.02-3.06h2.1v3.06h2.44v2.24h-2.44v6.72c-.07,1.56,1.09,2.1,2.58,1.7v2.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rect3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5-pm-3",
    d: "m457.86,545.11c-.01-3.31,2.67-6.01,5.98-6.02,0,0,.01,0,.02,0h330.24c3.31,0,6,2.69,6,6v86.67c0,3.31-2.69,6-6,6h-330.24c-3.31,0-6-2.69-6-6v-86.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aA-3",
    "data-name": "aA",
    className: "cls-13-pm-3",
    d: "m527.23,594.25v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-10",
    "data-name": "ay",
    className: "cls-13-pm-3",
    d: "m539.72,581.08c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-12",
    "data-name": "aB",
    className: "cls-13-pm-3",
    d: "m546.99,578.57v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-15",
    "data-name": "au",
    className: "cls-13-pm-3",
    d: "m554.73,591.06c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-13",
    "data-name": "aB",
    className: "cls-13-pm-3",
    d: "m559.14,578.57v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-16",
    "data-name": "au",
    className: "cls-13-pm-3",
    d: "m566.88,591.06c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-13",
    "data-name": "an",
    className: "cls-13-pm-3",
    d: "m579.24,591.81c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-17",
    "data-name": "au",
    className: "cls-13-pm-3",
    d: "m587.25,591.06c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-23",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m596.83,581.08c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    id: "av-9",
    "data-name": "av",
    className: "cls-13-pm-3",
    d: "m616.92,582.78c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-24",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m629.42,581.08c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-8",
    "data-name": "ao",
    className: "cls-13-pm-3",
    d: "m643.95,583.19c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-18",
    "data-name": "au",
    className: "cls-13-pm-3",
    d: "m648.29,591.06c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-14",
    "data-name": "aB",
    className: "cls-13-pm-3",
    d: "m652.71,578.57v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba-6",
    "data-name": "ba",
    className: "cls-13-pm-3",
    d: "m663.3,578.37c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-15",
    "data-name": "aB",
    className: "cls-13-pm-3",
    d: "m664.86,578.57v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-10",
    "data-name": "av",
    className: "cls-13-pm-3",
    d: "m675.12,582.78c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-14",
    "data-name": "an",
    className: "cls-13-pm-3",
    d: "m690.39,591.81c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-19",
    "data-name": "au",
    className: "cls-13-pm-3",
    d: "m698.41,591.06c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-16",
    "data-name": "aB",
    className: "cls-13-pm-3",
    d: "m702.82,578.57v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-12",
    "data-name": "ar",
    className: "cls-13-pm-3",
    d: "m713.34,581.08c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay-11",
    "data-name": "ay",
    className: "cls-13-pm-3",
    d: "m728.08,581.08c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-24-pm-3",
    d: "m626.39,491.47v30.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19-pm-3",
    d: "m626.89,491.48h-1v-.5h1v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20-pm-3",
    d: "m626.38,536.99l-4.62-14.27h9.26l-4.64,14.27Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "rect7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4-pm-3",
    d: "m455.26,1421.84c0-3.31,2.69-6,6-6h330.26c3.31,0,6,2.69,6,6h0v86.67c0,3.31-2.69,6-6,6h-330.26c-3.31,0-6-2.69-6-6v-86.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cc",
    className: "cls-13-pm-3",
    d: "m571.94,1448.27c-2.58-2.85-4.41-6.25-4.41-11.48s1.9-8.56,4.41-11.34h2.1c-2.58,2.78-4.35,6.25-4.35,11.41s1.77,8.62,4.35,11.41h-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cd",
    className: "cls-13-pm-3",
    d: "m589.86,1436.86c-.07,4.41-2.72,6.59-7.06,6.59s-6.79-2.17-6.79-6.38v-10.73h2.24c.54,6.04-2.24,15.21,4.55,15.21s4.35-9.03,4.82-15.21h2.24v10.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ce",
    className: "cls-13-pm-3",
    d: "m604.87,1443.18l-6.72-8.15-2.17,1.7v6.45h-2.24v-16.84h2.24v8.42l8.08-8.42h2.72l-7.13,7.33,8.08,9.51h-2.85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "af"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cf",
    className: "cls-13-pm-3",
    d: "m624.29,1426.13c5.5,0,8.35,3.12,8.35,8.56s-2.99,8.76-8.35,8.76-8.35-3.33-8.35-8.76,2.85-8.56,8.35-8.56Zm0,15.41c4.28,0,6.04-2.78,6.04-6.86s-1.97-6.72-6.04-6.72-6.04,2.65-6.04,6.72,1.9,6.79,6.04,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aV-2",
    "data-name": "aV",
    className: "cls-13-pm-3",
    d: "m646.7,1443.18l-8.96-14.33.07,14.33h-1.97v-16.84h2.65l9.03,14.46-.14-14.46h2.1v16.84h-2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aD-4",
    "data-name": "aD",
    className: "cls-13-pm-3",
    d: "m653.42,1443.18v-16.84h2.24v15.01h8.49v1.83h-10.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cg",
    className: "cls-13-pm-3",
    d: "m672.43,1436.18v6.99h-2.31v-6.99l-6.45-9.85h2.51l5.09,8.01,5.09-8.01h2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ch",
    className: "cls-13-pm-3",
    d: "m681.66,1425.46c2.58,2.78,4.41,6.25,4.41,11.41s-1.83,8.62-4.41,11.41h-2.1c2.51-2.78,4.35-6.25,4.35-11.41s-1.83-8.62-4.35-11.41h2.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ci",
    className: "cls-13-pm-3",
    d: "m508.41,1469.58l-1.9-4.89h-7.67l-1.9,4.89h-2.38l6.86-16.84h2.58l6.72,16.84h-2.31Zm-2.58-6.72l-3.19-8.35c-.81,3.06-2.1,5.57-3.12,8.35h6.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-9",
    "data-name": "ao",
    className: "cls-13-pm-3",
    d: "m518.53,1458.51c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-11",
    "data-name": "av",
    className: "cls-13-pm-3",
    d: "m525.39,1458.1c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-5",
    "data-name": "aq",
    className: "cls-13-pm-3",
    d: "m538.29,1458.1c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-17",
    "data-name": "aB",
    className: "cls-13-pm-3",
    d: "m546.3,1453.89v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bZ-3",
    "data-name": "bZ",
    className: "cls-13-pm-3",
    d: "m557.37,1469.58h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-25",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m569.05,1456.4c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("path", {
    id: "aX-3",
    "data-name": "aX",
    className: "cls-13-pm-3",
    d: "m584.67,1452.74c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84Zm2.24,8.49c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq-6",
    "data-name": "aq",
    className: "cls-13-pm-3",
    d: "m606.12,1458.1c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb-2",
    "data-name": "bb",
    className: "cls-13-pm-3",
    d: "m624.66,1456.68l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "at-8",
    "data-name": "at",
    className: "cls-13-pm-3",
    d: "m633.9,1459.87c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-18",
    "data-name": "aB",
    className: "cls-13-pm-3",
    d: "m638.58,1453.89v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "av-12",
    "data-name": "av",
    className: "cls-13-pm-3",
    d: "m648.83,1458.1c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-15",
    "data-name": "an",
    className: "cls-13-pm-3",
    d: "m664.11,1467.13c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bU-3",
    "data-name": "bU",
    className: "cls-13-pm-3",
    d: "m669.75,1469.58v-17.72h2.17v17.72h-2.17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ai"
  }, /*#__PURE__*/React.createElement("path", {
    id: "av-13",
    "data-name": "av",
    className: "cls-13-pm-3",
    d: "m686.79,1458.1c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar-13",
    "data-name": "ar",
    className: "cls-13-pm-3",
    d: "m699.28,1456.4c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "be-4",
    "data-name": "be",
    className: "cls-13-pm-3",
    d: "m713.88,1456.4c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31Zm-.54,11.81c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bb-3",
    "data-name": "bb",
    className: "cls-13-pm-3",
    d: "m731.81,1456.68l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ar-14",
    "data-name": "ar",
    className: "cls-13-pm-3",
    d: "m745.46,1456.4c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72Zm-.07,11.81c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ba-7",
    "data-name": "ba",
    className: "cls-13-pm-3",
    d: "m759.11,1453.69c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ax-8",
    "data-name": "ax",
    className: "cls-13-pm-3",
    d: "m597.7,1484.5c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-16",
    "data-name": "an",
    className: "cls-13-pm-3",
    d: "m613.32,1493.53c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au-20",
    "data-name": "au",
    className: "cls-13-pm-3",
    d: "m621.33,1492.79c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap-26",
    "data-name": "ap",
    className: "cls-13-pm-3",
    d: "m630.91,1482.8c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65Zm3.53,5.5c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao-10",
    "data-name": "ao",
    className: "cls-13-pm-3",
    d: "m645.44,1484.91c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aB-19",
    "data-name": "aB",
    className: "cls-13-pm-3",
    d: "m647.41,1480.29v-2.04h2.17v2.04h-2.17Zm0,15.69v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-17",
    "data-name": "an",
    className: "cls-13-pm-3",
    d: "m660.72,1493.53c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38Zm-6.31-1.15c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bU-4",
    "data-name": "bU",
    className: "cls-13-pm-3",
    d: "m666.35,1495.98v-17.72h2.17v17.72h-2.17"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-24-pm-3",
    d: "m620.5,1345.35v53.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19-pm-3",
    d: "m621,1345.36h-1v-.5h1v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20-pm-3",
    d: "m620.5,1413.22l-4.64-14.26h9.27l-4.63,14.26Z"
  }), /*#__PURE__*/React.createElement("a", {
    href: "#popup_flight_travlDil16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18-pm-3",
    d: "m382.41,953.15h32.06v20.28h-32.05v-20.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16-pm-3",
    d: "m382.4,973.52h32.05v20.88h-32.06v-20.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-pm-3",
    d: "m414.46,953.15h32.97v20.87h-32.97v-20.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21-pm-3",
    d: "m414.46,973.52h32.97v20.88h-32.97v-20.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-pm-3",
    d: "m380.5,962.25h33.95v2.67h-33.96v-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-pm-3",
    d: "m396.54,953.12v20.3h-2.96v-20.3h2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8-pm-3",
    d: "m429.26,953.22v20.3h-3.4v-20.3h3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8-pm-3",
    d: "m447.24,965.38h-32.83v-3.42h32.83v3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6-pm-3",
    d: "m396.73,973.52v20.95h-3.42v-20.95h3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6-pm-3",
    d: "m414.52,986.25h-32.1v-3.42h32.1v3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-pm-3",
    d: "m429.26,973.42v20.96h-3.4v-20.96h3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-pm-3",
    d: "m447.43,986.25h-33.02v-3.42h33.02v3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8-pm-3",
    d: "m428.6,973.42v21.02h-2.08v-21l2.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8-pm-3",
    d: "m447.46,985.58h-33v-2.08h33v2.08Z"
  })), /*#__PURE__*/React.createElement("a", {
    href: "#popup_flight_travlDil15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18-pm-3",
    d: "m152.63,750.37h32.06v20.28h-32.06v-20.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16-pm-3",
    d: "m152.62,770.75h32.04v20.87h-32.03v-20.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-pm-3",
    d: "m184.69,750.37h32.96v20.87h-32.97v-20.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21-pm-3",
    d: "m184.69,770.75h32.96v20.87h-32.97v-20.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-pm-3",
    d: "m150.72,759.47h33.94v2.67h-33.93v-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-pm-3",
    d: "m166.76,750.32v20.33h-2.96v-20.33h2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8-pm-3",
    d: "m199.49,750.42v20.33h-3.43v-20.33h3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8-pm-3",
    d: "m217.46,762.6h-32.83v-3.42h32.83v3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6-pm-3",
    d: "m166.94,770.72v20.97h-3.42v-20.97h3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6-pm-3",
    d: "m184.74,783.47h-32.1v-3.42h32.1v3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-pm-3",
    d: "m199.49,770.65v20.96h-3.43v-20.97h3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-pm-3",
    d: "m217.66,783.47h-33.04v-3.42h33.02l.02,3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8-pm-3",
    d: "m198.82,770.65v21h-2.08v-21h2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8-pm-3",
    d: "m217.68,782.8h-33v-2.08h33v2.08Z"
  })), /*#__PURE__*/React.createElement("a", {
    href: "#popup_flight_travlDil20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18-pm-3",
    d: "m382.41,445.72h32.06v20.3h-32.05v-20.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16-pm-3",
    d: "m382.4,466.12h32.05v20.86h-32.06v-20.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-pm-3",
    d: "m414.46,445.72h32.97v20.87h-32.97v-20.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21-pm-3",
    d: "m414.46,466.12h32.97v20.86h-32.97v-20.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-pm-3",
    d: "m380.5,454.82h33.95v2.67h-33.96v-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-pm-3",
    d: "m396.54,445.68v20.34h-2.96v-20.35h2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8-pm-3",
    d: "m429.26,445.79v20.33h-3.4v-20.34h3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8-pm-3",
    d: "m447.24,457.96h-32.83v-3.42h32.83v3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6-pm-3",
    d: "m396.73,466.09v20.96h-3.42v-20.96h3.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6-pm-3",
    d: "m414.52,478.82h-32.1v-3.4h32.1v3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-pm-3",
    d: "m429.26,466.02v20.94h-3.4v-20.94h3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-pm-3",
    d: "m447.43,478.82h-33.02v-3.4h33.02v3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8-pm-3",
    d: "m428.6,466.02v21h-2.08v-21h2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8-pm-3",
    d: "m447.46,478.15h-33v-2.07h33v2.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14-pm-3",
    d: "m380.3,32.62h66.94v35.1h-66.94v-35.1Z"
  }), /*#__PURE__*/React.createElement("a", {
    href: "#popup_flight_travlDil14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10-pm-3",
    d: "m385.86,565.62h64.1v33.6h-64.1v-33.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-pm-3",
    d: "m454.21,567.38l-68.7,34.63-2.3-4.57,68.7-34.62,2.3,4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18-pm-3",
    d: "m453.09,565.32l-68.7,34.64-.7-1.35,68.73-34.64.67,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-pm-3",
    d: "m450.96,602.02l-68.43-35.2,2.34-4.55,68.43,35.2-2.34,4.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18-pm-3",
    d: "m424.76,587l-42.23-21.73.63-1.22,42.23,21.73-.63,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18-pm-3",
    d: "m452.02,599.5l-24.66-12.68.66-1.3,24.66,12.7-.66,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-pm-3",
    d: "m383.66,577.84h69.02v9.16h-69l-.02-9.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-pm-3",
    d: "m422.49,563.92v36.2h-9.16v-36.2h9.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18-pm-3",
    d: "m383.66,579.32h69.02v6.2h-69l-.02-6.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18-pm-3",
    d: "m421.02,564.65v35.31h-6.22v-35.31h6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10-pm-3",
    d: "m382.66,395.85h64.08v33.6h-64.1l.02-33.6Z"
  }), /*#__PURE__*/React.createElement("a", {
    href: "#popup_flight_travlDil13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3-pm-3",
    d: "m451,397.62l-68.72,34.6-2.3-4.56,68.72-34.63,2.3,4.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18-pm-3",
    d: "m449.88,395.55l-68.72,34.63-.68-1.35,68.72-34.61.68,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-pm-3",
    d: "m447.74,432.24l-68.42-35.2,2.33-4.54,68.4,35.2-2.31,4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18-pm-3",
    d: "m421.56,417.22l-42.25-21.73.63-1.22,42.24,21.73-.62,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18-pm-3",
    d: "m448.8,429.72l-24.64-12.67.65-1.28,24.65,12.67-.66,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-pm-3",
    d: "m380.46,408.07h69v9.15h-69v-9.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-pm-3",
    d: "m419.26,394.15v36.2h-9.14v-36.2h9.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18-pm-3",
    d: "m380.46,409.52h69v6.24h-69v-6.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18-pm-3",
    d: "m417.81,393.42v36.76h-6.23v-36.76h6.23Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12-pm-3",
    x: 376.24,
    y: 1444.24,
    width: 5.73,
    height: 38.9
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12-pm-3",
    x: 377.54,
    y: 389.39,
    width: 74.14,
    height: 6.11
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12-pm-3",
    x: 377.23,
    y: 389.39,
    width: 4.98,
    height: 41.58
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12-pm-3",
    x: 377.54,
    y: 429.95,
    width: 73.46,
    height: 5.53
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12-pm-3",
    x: 447.2,
    y: 389.53,
    width: 5.7,
    height: 45.44
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12-pm-3",
    x: 376.62,
    y: 1109.48,
    width: 73.83,
    height: 6.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12-pm-3",
    x: 374.48,
    y: 1109.48,
    width: 6.54,
    height: 41.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12-pm-3",
    x: 446.05,
    y: 1109.48,
    width: 5.04,
    height: 41.6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12-pm-3",
    x: 374.42,
    y: 1149.92,
    width: 76.68,
    height: 3.34
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12-pm-3",
    x: 376.24,
    y: 1443.32,
    width: 73.72,
    height: 4.28
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12-pm-3",
    x: 376.24,
    y: 1482.16,
    width: 73.72,
    height: 3.86
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12-pm-3",
    x: 447.21,
    y: 1443.25,
    width: 5.5,
    height: 42.7
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12-pm-3",
    x: 380.14,
    y: 561.87,
    width: 5.17,
    height: 41.11
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12-pm-3",
    x: 379.53,
    y: 559.53,
    width: 74.68,
    height: 5.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12-pm-3",
    x: 450.43,
    y: 559.53,
    width: 5.43,
    height: 42.11
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12-pm-3",
    x: 382.53,
    y: 599.73,
    width: 72.78,
    height: 4.24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmPhase3);
export default __webpack_public_path__ + "static/media/PM_Phase_3.9a86f42862fc30bd3cb8322c4e686b30.svg";
export { ForwardRef as ReactComponent };